// src/components/DictionaryCard.ts
import "./DictionaryCard.css";

export async function renderDictionaryCard(
  container: HTMLElement,
  query: string,
): Promise<void> {
  container.innerHTML = `<div class="card-container dict-card">Loading definition...</div>`;

  try {
    const res = await fetch(
      `https://api.ayesearch.com/api/dictionary/?q=${encodeURIComponent(query)}`,
    );
    const data = await res.json();

    container.innerHTML = `
      <div class="card-container dict-card">
        <div class="dict-word">${data.word}</div>
        <div class="dict-phonetic">${data.phonetic || ""}</div>
        <div class="dict-definition">${data.definition}</div>
      </div>
    `;
  } catch {
    container.innerHTML = `
      <div class="card-container dict-card">
        <div class="dict-definition">No definition found.</div>
      </div>
    `;
  }
}
